import { Component, inject } from '@angular/core';
import { EventService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  EventCreateDto,
  EventDto,
  EventExcelDownloadDto,
  EventUpdateDto,
} from '../proxy/controlling/dtos/event';
import { EVENT_CONFIG, EVENT_FIELDS } from './event.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-event',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, EventService, ConfirmationService],
  templateUrl: './event.html',
  styleUrl: './event.scss',
})
export class Event extends BaseCrudComponent<
  EventDto,
  EventCreateDto,
  EventUpdateDto,
  EventExcelDownloadDto
> {
  service = inject(EventService);
  config = EVENT_CONFIG;
  fields = EVENT_FIELDS;

  protected prepareUpdateDto(data: any, selected: EventDto): EventUpdateDto {
    return {
      name: data.name,
      eventCategoryId: data.eventCategoryId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Event';
  }
}
